import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { AutotextService } from 'src/app/autotext.service';
import { ExamsService } from 'src/app/exams.service';
import { CardioService } from '../cardio.service';

@Component({
    selector: 'app-cardio-findings',
    templateUrl: './cardio-findings.component.html',
    styleUrls: ['./cardio-findings.component.scss'],
    standalone: false
})
export class CardioFindingsComponent implements OnInit, OnDestroy {
  @Input() updateExercise$: Observable<void>;
  private updateExerciseSub: Subscription;

  FindingsForm: UntypedFormGroup;
  sub = new Subscription()
  groups = [ 'Response','Arythmia','Conduction','ST','EndReason','ECG'];
  findings = ['CCA', 'Bulb', 'ICAProx', 'MidICA', 'ECA', 'VA','IMT'];
  DurationMinutes: any;
  DurationSeconds: any;
  PatNotesForm
  patNotes=[]

  constructor(private fb:UntypedFormBuilder, public es: ExamsService,public atS:AutotextService, public cardioS:CardioService) { 
    this.FindingsForm = this.fb.group({
      Duration: [''],
      Stage:[''],
      METs:[''],
      HeartRate:[''],
      MaxExpectedHeartRate:[''],
      MaxHeartRate:[''],
      MinHeartRate:[''],
      Precentage:[''],
      bpSystolicRest:[''],
      bpDiastolicRest:[''],
      bpSystolic:[''],
      bpDiastolic:[''],
      Response:[''],
      Arythmia:[''],
      Conduction:[''],
      ST:[''],
      EndReason:[''],
      PulseRate:[''],
      PulseStatus:[''],
      Medication:[''],
      Protocol:[''],
      OtherStaff:[''],
      ECG:[''],
      BasicRhythm:[''],
      STchanges:[''],
      SupraVentricularArrhythmia:[''],
      VentricularArrhythmia:[''],
      startDateHolter:[''],
      startTimeHolter:[''],
      endDateHolter:[''],
      endTimeHolter:[''],
      maxBPUpper :[''],
      maxBPLower  :[''],
      minBPUpper  :[''],
      minBPLower  :[''],
      DurationMin:[''],
      DurationHours:[''],
      Conductiondisturbances:[''],
      AverageHRtotal:[null],
      AverageHRWake:[null],
      AverageHRSleep:[null],
      baselineHeartrate:[''],
    });
  }

  ngOnInit() {
    this.es.fillForm(this.FindingsForm,"cardioFindings",false,true);

    const maxExpectedHeartRate = this.FindingsForm.get('MaxExpectedHeartRate');
    const protocol = this.FindingsForm.get('Protocol');
    const maxHeartRate = this.FindingsForm.get('MaxHeartRate');
    const percentage = this.FindingsForm.get('Precentage');
  
     if(this.es.ExamType !== 'Holter ECG'){
    this.sub = this.es.formLoaded$.subscribe(() => {
      const age = this.es.patServ.getPat().getAge().split(" ")[0];
      if (!this.es.isClosed) {
        maxExpectedHeartRate.setValue(220- (Number(age)));
      }
      if(! protocol.value)
        protocol.setValue('Bruce', {emitEvent: false})
      this.sub = maxHeartRate.valueChanges.subscribe((data) => {
        var prec = null;
        if(data && + maxExpectedHeartRate.value){
          var MHR = data;
          var EMHR = + maxExpectedHeartRate.value
          prec = (MHR / EMHR) * 100;
          prec = prec.toString().split('.')[0];
        }
        if(prec == Infinity){
          prec = null;
        }
        percentage.patchValue(prec);
      })

      this.calculatePercentage();
      
      const durationParts = this.FindingsForm.get("Duration").value;
      const convertedDuration = String(durationParts).split(".");

      if (convertedDuration.length > 1) {
        this.DurationMinutes = convertedDuration[0];
        this.DurationSeconds = convertedDuration[1];
      } else {
        this.DurationMinutes = this.FindingsForm.get("Duration").value;
        this.DurationSeconds = "";
      }
    });
  }
  if(this.es.ExamType == 'Holter ECG'){
    this.resetPatNoteForm()
      this.loadPatNotes()
   }
    this.sub = this.FindingsForm.get('startDateHolter').valueChanges.subscribe((data) => {
      this.calcDuration(this.FindingsForm.get('startDateHolter').value, this.FindingsForm.get('startTimeHolter').value, this.FindingsForm.get('endDateHolter').value, this.FindingsForm.get('endTimeHolter').value)

    })
    this.sub = this.FindingsForm.get('startTimeHolter').valueChanges.subscribe((data) => {
      this.calcDuration(this.FindingsForm.get('startDateHolter').value, this.FindingsForm.get('startTimeHolter').value, this.FindingsForm.get('endDateHolter').value, this.FindingsForm.get('endTimeHolter').value)

    })
    this.sub = this.FindingsForm.get('endDateHolter').valueChanges.subscribe((data) => {
      this.calcDuration(this.FindingsForm.get('startDateHolter').value, this.FindingsForm.get('startTimeHolter').value, this.FindingsForm.get('endDateHolter').value, this.FindingsForm.get('endTimeHolter').value)

    })
    this.sub = this.FindingsForm.get('endTimeHolter').valueChanges.subscribe((data) => {
      this.calcDuration(this.FindingsForm.get('startDateHolter').value, this.FindingsForm.get('startTimeHolter').value, this.FindingsForm.get('endDateHolter').value, this.FindingsForm.get('endTimeHolter').value)

    })

    this.updateExerciseSub = this.updateExercise$.subscribe(() => {
      this.calculatePercentage();
    });
  }

  
  ngOnDestroy(): void {
    if(this.sub) {
      this.sub.unsubscribe()
    }

    if(this.updateExerciseSub) {
      this.updateExerciseSub.unsubscribe()
    }
  }

  calculatePercentage() {
    if (this.es.isClosed) {
      return;
    }
    let prec = null;
    const maxHeartRate = this.FindingsForm.get('MaxHeartRate');
    const maxExpectedHeartRate = this.FindingsForm.get('MaxExpectedHeartRate');
    const percentage = this.FindingsForm.get('Precentage');
    const age = this.es.patServ.getPat().getAge().split(" ")[0];
      maxExpectedHeartRate.setValue(220- (Number(age)));
   

    if (maxHeartRate?.value && maxExpectedHeartRate?.value) {
      const MHR = maxHeartRate.value;
      const EMHR = +maxExpectedHeartRate.value;
      prec = (MHR / EMHR) * 100;
      prec = prec.toString().split(".")[0];
    }
    percentage?.patchValue(prec);
  }

  resetPatNoteForm() {
    this.PatNotesForm = this.fb.group({
      clinicalFindings: [''],
      patientNote: [''],
      Hour: [],
      Min: [] 
    });
     console.log(this.PatNotesForm.get('patientNote'),'pat note')
    this.atS.resetInput$.next(this.PatNotesForm.get('patientNote').value);
  }
  

  savePatNote(){
    if(!this.PatNotesForm.get('Hour').value || !this.PatNotesForm.get('Min').value) return
    this.cardioS.savePatNote(this.PatNotesForm.value).subscribe(()=>{
      this.loadPatNotes()
      this.resetPatNoteForm();

    })
  }

  deleteNote(noteId:number){
    if (!noteId) return

    this.cardioS.deleteNote(noteId).subscribe(()=>{
      this.loadPatNotes()
    })

  }

  
  loadPatNotes(){
    var res = this.cardioS.getAllPatNotes();
    res.subscribe((data:any) =>{
      this.patNotes = data;
    })
  }

  updateDuration() {
    const durationSeconds = Number(this.DurationSeconds) || 0;
    const durationMinutes = Number(this.DurationMinutes) || 0;

    const combinedDuration = `${durationMinutes}.${durationSeconds}`;
    this.FindingsForm.get("Duration").setValue(combinedDuration);
  }

  limitSeconds() {
    const maxDuration = 59;
    const value = Number(this.DurationSeconds);
    if (isNaN(value) || value > maxDuration) {
      this.DurationSeconds = maxDuration;
    }
  }

  calcDuration(startDate,startTime,endDate,endTime){
  const startDateTime = new Date(startDate + ' ' + startTime);
  const endDateTime = new Date(endDate + ' ' + endTime);

  if (!isNaN(startDateTime.getTime()) && !isNaN(endDateTime.getTime())) {
    const timeDifference = endDateTime.getTime() - startDateTime.getTime(); // Difference in milliseconds

    // Calculate hours and seconds
    const hours = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
   

    console.log('Hours:', hours);
    console.log('Minutes:', minutes);
    this.FindingsForm.get('DurationMin').setValue(minutes);
    this.FindingsForm.get('DurationHours').setValue(hours)

  } else {
    this.FindingsForm.get('DurationHours').setValue("");
    this.FindingsForm.get('DurationMin').setValue("");

  }
}
}
